/* Publish by EComposer at 2025-07-28 21:19:51*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-t8z0llcj18d"]=  window.__ectimmers["ecom-t8z0llcj18d"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-t8z0llcj18d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t8z0llcj18d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-82eo66p44t5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-82eo66p44t5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gtvubbn1ikn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gtvubbn1ikn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ffxxm7j81sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ffxxm7j81sc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-c02fv2yst1b"]=  window.__ectimmers["ecom-c02fv2yst1b"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-c02fv2yst1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c02fv2yst1b', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ej8j31irdx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ej8j31irdx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wajl5wge3oj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wajl5wge3oj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rck8ucjmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rck8ucjmc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}